import css from 'styled-jsx/css';

export const ImageGroupStyles = css`
  div {
    overflow: hidden;
    cursor: pointer;
    position: relative;
  }

  /* div > :global(img) {
    transition: all 0.5s ease;
    display: none;
  }
  div > :global(img:first-child) {
    display: inherit;
  } */

  section {
    display: block;
    overflow: hidden;
    width: 100%;
    height: auto;

    /* background: #fdfdfd; */
  }

  .grid-view {
    max-height: 496px;
    @mixin tabletToDesktop {
      max-height: 248px;
    }
  }
  section > :global(img) {
    width: 100%;
    height: 100%;
    transition: transform 0.5s ease-out, -webkit-transform 0.5s ease-out;
    display: block;
  }
  section > :global(picture) {
    width: 100%;
    height: 100%;
    transition: transform 0.5s ease-out, -webkit-transform 0.5s ease-out;
    display: block;
  }
  section > :global(picture > img) {
    display: block;
  }
  section.image--active > :global(img) {
    transform: scale(1.05);
  }
  section.image--active > :global(picture) {
    transform: scale(1.05);
  }
  section > :global(img):nth-child(2) {
    display: none;
  }
  section > :global(picture):nth-child(2) {
    display: none;
  }
`;
